import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = '+919032797797'; // Your WhatsApp number
  const message = encodeURIComponent(
    `Hi! I'm interested in booking a stay at Skyline Backpackers. Could you please help me with availability and pricing? 🏨`
  );
  
  const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${message}`;
  
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contact us on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="whatsapp-text">Chat with us</span>
    </a>
  );
};

export default WhatsAppButton;
